import Enums from '@core/types/api/Enums';

// The server lease is 30s; renewing every 10s survives one missed heartbeat.
export const EDIT_LOCK_HEARTBEAT_MS = 10_000;
export const EDIT_LOCK_EXPIRY_GRACE_MS = 1_000;

export const QUOTE_EDIT_LOCK_ROUTES = {
  entity: Enums.EditLockEntity.Quote,
  list: 'GET quote edit locks',
  acquire: 'POST quote edit locks',
  release: 'DELETE quote edit locks',
} as const;

export type EditLockRoutes = typeof QUOTE_EDIT_LOCK_ROUTES;
